import {
  PlaybookContentIntegrationType,
  type PlaybookContentGuide,
  type PlaybookContentPlanType,
} from "../state/api.types";

export function initPlaybookPerspective() {
  const playbookPreview = new URLSearchParams(window.location.search).get(
    "sanity-preview-perspective",
  );
  if (playbookPreview && playbookPreview !== "published") {
    sessionStorage.setItem("playbook_perspective", playbookPreview);
  }
  return playbookPreview;
}

export function getPlaybookPerspective() {
  return sessionStorage.getItem("playbook_perspective");
}

export function setPlaybookPerspective(perspective: string | null | undefined) {
  if (perspective) {
    sessionStorage.setItem("playbook_perspective", perspective);
  } else {
    sessionStorage.removeItem("playbook_perspective");
  }
}

export function filterPlaybookGuides<
  T extends Pick<PlaybookContentGuide, "integration" | "plan_types">,
>(
  guides: T[],
  planFilter: PlaybookContentPlanType | null,
  integrationFilter: PlaybookContentIntegrationType | null,
) {
  return guides.filter((guide) => {
    if (planFilter && !guide.plan_types.includes(planFilter)) {
      return false;
    }
    const integration = guide.integration as PlaybookContentIntegrationType;
    if (
      integrationFilter &&
      integrationFilter !== PlaybookContentIntegrationType.All &&
      integration !== PlaybookContentIntegrationType.All &&
      integration !== integrationFilter
    ) {
      return false;
    }
    return true;
  });
}
